import { Box, Link } from '@mui/material';

interface WidgetMoreLinkProps {
  hiddenCount: number;
  label?: string;
  onClick?: () => void;
  href?: string;
}

/**
 * Tiny footer link rendered by list-style widgets when their underlying data
 * exceeds `widgetTokens.maxRows`. Keeping it in one place means every widget
 * shows the same "View all (N more)" affordance with identical styling.
 */
export function WidgetMoreLink({
  hiddenCount,
  label = 'View all',
  onClick,
  href,
}: WidgetMoreLinkProps) {
  if (hiddenCount <= 0) return null;

  const text = `${label} (${hiddenCount} more)`;

  return (
    <Box sx={{ mt: 1 }}>
      {href ? (
        <Link
          href={href}
          underline="hover"
          sx={{ fontSize: 12, fontWeight: 500 }}
        >
          {text}
        </Link>
      ) : (
        <Link
          component="button"
          type="button"
          onClick={onClick}
          underline="hover"
          sx={{
            fontSize: 12,
            fontWeight: 500,
            // Align with the list items above so the link doesn't drift.
            p: 0,
          }}
        >
          {text}
        </Link>
      )}
    </Box>
  );
}
